import { render } from "./MarketingGuru.vue?vue&type=template&id=40ae2e7b&scoped=true"
import script from "./MarketingGuru.vue?vue&type=script&lang=js"
export * from "./MarketingGuru.vue?vue&type=script&lang=js"

import "./MarketingGuru.vue?vue&type=style&index=0&id=40ae2e7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ae2e7b"]])

export default __exports__